<template>
  <div class="card card-custom" v-if="video">
    <div class="card-body p-0">
      <div class="row justify-content-center my-10 px-8 my-lg-15 px-lg-10">

        <div class="col-xl-12">
          <v-tabs
            v-model="tab"
            background-color="pink lighten-2"
            grow
            icons-and-text
            dark
            class="mb-10"
          >
            <v-tabs-slider></v-tabs-slider>

            <v-tab href="#tab-FR">
              Français
              <img
                src="/media/svg/flags/019-france.svg"
                class="h-20px w-20px rounded-sm"
              />
            </v-tab>
            <v-tab href="#tab-EN">
              Anglais
              <img
                src="/media/svg/flags/226-united-states.svg"
                class="h-20px w-20px rounded-sm"
              />
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item value="tab-FR">
              <v-form ref="form">
                <FormVideoStep2
                  v-if="video"
                  v-model="video"
                  @openFileDropEdit="fileDialog = true"
                ></FormVideoStep2>
              </v-form>
            </v-tab-item>
            <v-tab-item value="tab-EN">
              <v-form ref="form2">
                <FormVideoStep3 v-model="video"></FormVideoStep3>
              </v-form>
            </v-tab-item>
          </v-tabs-items>

          

          <v-btn class="ma-2 float-right" color="primary" @click="submit">
            Valider les modifications
          </v-btn>
        </div>
      </div>
    </div>
    <v-dialog v-model="fileDialog">
      <v-card>
        <v-card-title>
          Modifier les fichiers de la vidéo
        </v-card-title>

        <div class="p-5">
          <FormVideoStep1 v-model="video"></FormVideoStep1>
        </div>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="fileDialog = false">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Api from "@/core/services/api.service";
import Swal from "sweetalert2";

import FormVideoStep1 from "@/components/admin/video/forms/wizard/formVideoStep1.vue";
import FormVideoStep2 from "@/components/admin/video/forms/wizard/formVideoStep2.vue";
import FormVideoStep3 from "@/components/admin/video/forms/wizard/formVideoStep3.vue";

export default {
  name: "editVideo",
  components: {
    FormVideoStep1,
    FormVideoStep2,
    FormVideoStep3,
  },
  data: () => ({
    dialog: false,
    dialog2: false,
    tab: null,
    video: null,
    fileDialog: false,
    themes: [],
    open: [1, 2],
    search: null,
    caseSensitive: false,
    userRights: [],
    users: [],
    //usersLength:[]
  }),
  computed: {
    // videoForWatcher is used to watch the video data (otherwise, the old/new values are the same as they could reference the same object)
    videoForWatcher() {
      return Object.assign({}, this.video);
    }
  },
  watch: {
    videoForWatcher: {
      deep: true,
      handler(newVideo, oldVideo) {
        const newClientId = newVideo.client ? newVideo.client['@id'] : null;
        const oldClientId = oldVideo.client ? oldVideo.client['@id'] : null;
        const newThemeId = newVideo.theme && newVideo.theme[0] ? newVideo.theme[0]['@id'] : null;
        const oldThemeId = oldVideo.theme && oldVideo.theme[0] ? oldVideo.theme[0]['@id'] : null;
        if (oldVideo === null || newClientId !== oldClientId || newThemeId !== oldThemeId) {
          this.refreshUsers();
        }
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Administration", route: "gestionContenus" },
      { title: "Gestion des contenus", route: "gestionContenus" },
      { title: "Modifier une vidéo" },
    ]);

    // TODO: Refactoring: Supprimer cette appel API qui semble ne pas être utile ?
    Api.get("themes").then((themes) => {
      this.themes = themes.data["hydra:member"];
    });

    const videoId = this.$route.params.id;
    const videoData = this.$route.params.video;

    if (videoData) {
      this.populateVideoForm(videoData);
    } else {
      Api.get('videos', videoId, { headers: { 'Accept-Language': 'fr_FR' } }).then((video) => {
        this.populateVideoForm(video.data);
      });
    }
    this.refreshUsers();
  },
  methods: {
    submit: async function() {
      if (!this.$refs.form.validate()) {
         Swal.fire({
            //Swal = Sweet Alert
            title: "Impossible de modifier la vidéo",
            text: "Vérifier les champs du formulaire avant de pouvoir modifier la vidéo. Certaines informations sont obligatoires et signalées par un astérisque (*)",
            icon: "warning",
            confirmButtonClass: "btn btn-secondary",
          });
      } else {
        const keywords = await Promise.all([
          ...this.video.keywords.visibleFR.map((k) =>
            typeof k === "string"
              ? Api.post("keywords", {
                  name: k,
                  lang: "FR",
                  isVisible: true,
                }).then((res) => res.data)
              : Promise.resolve(k)
          ),
          ...this.video.keywords.visibleEN.map((k) =>
            typeof k === "string"
              ? Api.post("keywords", {
                  name: k,
                  lang: "EN",
                  isVisible: true,
                }).then((res) => res.data)
              : Promise.resolve(k)
          ),
          ...this.video.keywords.invisibleFR.map((k) =>
            typeof k === "string"
              ? Api.post("keywords", {
                  name: k,
                  lang: "FR",
                  isVisible: false,
                }).then((res) => res.data)
              : Promise.resolve(k)
          ),
          ...this.video.keywords.invisibleEN.map((k) =>
            typeof k === "string"
              ? Api.post("keywords", {
                  name: k,
                  lang: "EN",
                  isVisible: false,
                }).then((res) => res.data)
              : Promise.resolve(k)
          ),
        ]);

        let response;
        try {
          response = await Api.patch('videos', this.video.id, {
            title: this.video.title,
            titleEN: this.video.titleEN,
            description: this.video.description,
            descriptionEN: this.video.descriptionEN,
            keywords: keywords.map((k) => k["@id"]),
            theme: this.video.theme[0]["@id"],
            client: this.video.client ? this.video.client["@id"] : null,
            partner: this.video.partner ? this.video.partner["@id"] : null,
            views : Number(this.video.views) ? Number(this.video.views) : 0,
            isVisible: this.video.isVisible,
          }, { headers: { 'Accept-Language': 'fr_FR' } });
          await Api.patch('videos', response.data.id, {
            title: this.video.titleEN,
            description: this.video.descriptionEN
          }, { headers: { 'Accept-Language': 'en_GB' } });
        } catch (error) {
          console.error(error);
          Swal.fire({
            title: "",
            text: "Une erreur est survenue lors de la modification de la vidéo",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
          });
          return;
        }

        var bodyvideo = new FormData();
        bodyvideo.append("poster", this.video.posterFile);
        bodyvideo.append("video", this.video.videoFile);

        try {
          if (this.video.posterFile && this.video.videoFile)
            await Api.post(`videos/${response.data.id}/media`, bodyvideo);
          Swal.fire({
            title: "",
            text: "La vidéo a été modifiée.",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
          });
          this.$router.push({ name: "gestionContenus", query: {
                  selected: 'tab-videos',
                }, });
        } catch (error) {
          let message = error?.response?.data?.["hydra:description"] || error?.response?.data?.detail || "Les fichiers fournis sont invalides ou non conformes.";
          //Dans le cas où la première requête à réussi, mais que nous n'avons pas réussi à rajouter les fichiers avec la 2eme requête
          Swal.fire({
            title: "Création annulée",
            text: message,
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
          });
        }
      }
    },
    populateVideoForm: async function(video) {
      const response = await Api.get('videos', video.id, { headers: { 'Accept-Language': 'en_GB' } });
      this.video = {
        //SPREAD OPERATOR (...)
        //Décomposition d'objets, permet de récupérer toutes les propriétés d'un objet d'un coup et de n'en surcharger
        //que certaines (par exemple Keywords, qu'on a besoin de traiter à part )
        ...video,
        titleEN: response.data.title,
        descriptionEN: response.data.description,
        videoFile: null,
        posterFile: null,

        keywords: {
          visibleEN: video.keywords.filter(
            (k) => k.lang === "EN" && k.isVisible
          ),
          visibleFR: video.keywords.filter(
            (k) => k.lang === "FR" && k.isVisible
          ),
          invisibleEN: video.keywords.filter(
            (k) => k.lang === "EN" && !k.isVisible
          ),
          invisibleFR: video.keywords.filter(
            (k) => k.lang === "FR" && !k.isVisible
          ),
        },
        theme: [video.theme],
      };
    },
    removeActiveTheme() {
      this.video.themeSelected = [];
    },
    refreshUsers() {
      if (this.video) {
        Api.query("user_rights", { params: { themes: this.video.theme[0].id } })
            .then(response => {
              const userRights = response.data["hydra:member"];
              this.userRights = userRights;
              //if (typeof this.video.client === 'undefined' || !this.video.client) {
              this.users = [...new Set(userRights.map(ur => ur.users).flat())];
              //}
              if(this.video.client){
                this.users = this.users.filter((u)=>u.client['@id'] === this.video.client['@id'])
              }
            })
            .catch(err => console.log(err))
            .finally(() => this.isLoading = false);
      }
    }

  },
};
</script>
